import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, Button } from "react-bootstrap";
import FieldGroup from "../components/FieldGroup";
import DomainName from "../components/DomainName";
import MessagePurpose from "../components/MessagePurpose";
import BlockUi from "react-block-ui";
import API from "../api/client";
import "react-block-ui/style.css";
import "./ContactForm.css";

class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = fillParamsFromUrl({
      blocking: false,

      domainName: "",
      name: "",
      purpose: "owner",
      email: "",
      subject: "",
      message: "",

      displayErrors: false,

      captchaResponse: "",
      captchaPublicKey: process.env.REACT_APP_CONTACT_OWNER_RECAPTCHA_PUBLIC_KEY
    });

    this.baseState = this.state;

    this.recaptchaRef = React.createRef();

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePurposeChange = this.handlePurposeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVerifyCaptcha = this.handleVerifyCaptcha.bind(this);
    this.enableBlocking = this.enableBlocking.bind(this);
    this.disableBlocking = this.disableBlocking.bind(this);
    this.onCaptchaChange = this.onCaptchaChange.bind(this);
  }

  enableBlocking() {
    this.setState({ blocking: true });
  }

  disableBlocking() {
    this.setState({ blocking: false });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { createNotification } = this.props;

    if (!event.target.checkValidity()) {
      this.setState({ displayErrors: true });
      return;
    }

    const {
      domainName,
      name,
      purpose,
      email,
      subject,
      message
    } = this.state;

    this.enableBlocking();

    const grecaptcha = window.grecaptcha
    const localThis = this
    grecaptcha.ready(function() {
      grecaptcha.execute(localThis.state.captchaPublicKey, {action: 'submit'}).then(function(token) {
        const payload = {
          domainName,
          name,
          purpose,
          email,
          subject,
          message,
          "g-recaptcha-response": token
        };

        API.sendEmail(localThis.state.domainName, payload, ({ error }) => {
          localThis.disableBlocking();
    
          if (!error) {
            createNotification("success", localThis.props.t('notification.success.header'), localThis.props.t('notification.success.text'));
            localThis.setState(localThis.baseState);
          } else {
            createNotification("danger", localThis.props.t('notification.danger.header'), error);
          }
        });
      }).catch((error) => {
        localThis.disableBlocking();
        createNotification("danger", localThis.props.t('notification.danger.header'), "Unable to contact domain owner");
      });
    })
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const id = target.id;

    this.setState({
      [id]: value
    });
  }

  handlePurposeChange(v) {
    this.setState({ purpose: v });
  }

  handleVerifyCaptcha(response) {
    this.setState({ captchaResponse: response });
  }

  onCaptchaChange(value) {
    if (value) {
      this.handleVerifyCaptcha(value)
    }
  }

  render() {
    const { displayErrors, blocking } = this.state;
    return (
      <div>
        <BlockUi tag="div" blocking={this.state.blocking}>
          <form
            className={`ContactForm ${displayErrors ? "is-invalid" : ""}`}
            onSubmit={this.handleSubmit}
            noValidate
          >
            <FormControl.Static>
              {this.props.t('form.info')}
            </FormControl.Static>
            <DomainName
              value={this.state.domainName}
              handleChange={this.handleInputChange}
              required
            />
            <MessagePurpose
              value={this.state.purpose}
              handleChange={this.handlePurposeChange}
            />
            <FieldGroup
              id="name"
              type="text"
              label={this.props.t('form.fields.name.label')}
              placeholder={this.props.t('form.fields.name.placeholder')}
              value={this.state.name}
              onChange={this.handleInputChange}
              required
            />
            <FieldGroup
              id="email"
              type="email"
              label={this.props.t('form.fields.email.label')}
              placeholder={this.props.t('form.fields.email.placeholder')}
              value={this.state.email}
              onChange={this.handleInputChange}
              required
            />
            <FieldGroup
              id="subject"
              type="text"
              label={this.props.t('form.fields.subject.label')}
              placeholder={this.props.t('form.fields.subject.placeholder')}
              value={this.state.subject}
              onChange={this.handleInputChange}
              required
            />
            <FieldGroup
              id="message"
              componentClass="textarea"
              label={this.props.t('form.fields.message.label')}
              placeholder={this.props.t('form.fields.message.placeholder')}
              value={this.state.message}
              onChange={this.handleInputChange}
              required
            />
            <FormGroup>
              <hr />
              <Button
                className="pull-right"
                type="submit"
                disabled={blocking}
              >
                {this.props.t('form.submit')}
              </Button>
            </FormGroup>
          </form>
        </BlockUi>
      </div>
    );
  }
}

function fillParamsFromUrl(obj) {
  var urlParams = new URLSearchParams(window.location.search);
  return Object.keys(obj).reduce((map, key) => {
    map[key] = urlParams.has(key) ? urlParams.get(key) : obj[key];
    return map;
  }, {});
}

export default withTranslation()(ContactForm);



// WEBPACK FOOTER //
// ./src/containers/ContactForm.js